module.exports = __webpack_public_path__ + "media/call.892b942c.mp3";